// removed by extract-text-webpack-plugin
module.exports = {"descriptionInput":"DescriptionInput__descriptionInput__1ddZU"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Common/Input/TextBoxes/DescriptionInput/DescriptionInput.scss
// module id = 1737
// module chunks = 0